// Module
var code = `<div class="alert-widget">
    <div class="table-container-row">
        <div class="table-container-column">
            <div class="title">{{.bidLabel}}</div>
            <div class="value bid-value">{{bid_str_value}}</div>
        </div>
        <div class="table-container-column">
            <div class="title">{{.askLabel}}</div>
            <div class="value ask-value">{{ask_str_value}}</div>
        </div>
        <div class="table-container-column">
            <div class="title">{{.lastLabel}}</div>
            <div class="value {{coloringLast}}">{{last_str_value}}</div>
        </div>
    </div>
    <div class="table-container-row">
        <div class="table-container-column">
            <div class="title">{{.changeLabel}}</div>
            <div class="value {{coloringChange}}">{{change_str_value}}</div>
        </div>
        <div class="table-container-column">
            <div class="title">{{.volumeLabel}}</div>
            <div class="value {{coloringVolume}}">{{volume_str_value}}</div>
        </div>
    </div>
</div>`;
// Exports
export default code;